import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/guard/auth.guard';
import { AnnouncementComponent } from './equipment-settings/announcement/announcement.component';
import { EntertainmentAppComponent } from './equipment-settings/entertainment/entertainment-app/entertainment-app.component';
import { EntertainmentComponent } from './equipment-settings/entertainment/entertainment.component';
import { EntertainmentInternetComponent } from './equipment-settings/entertainment/internet/entertainment-internet.component';
import { EntertainmentIptvComponent } from './equipment-settings/entertainment/iptv/entertainment-iptv.component';
import { FeatureFlagsComponent } from './feature-flags/feature-flags.component';

const hybridImpersonatedRoutes: Routes = [
  { path: '', redirectTo: '/equipmentSettings/announcement', pathMatch: 'full' },
  {
    path: 'equipmentSettings/announcement',
    component: AnnouncementComponent,
    canActivate: [AuthGuard],
    data: {
      meta: {
        title: 'ANNOUNCEMENT',
        breadcrumb: ['MENU.EQUIPSETTING', 'ANNOUNCEMENT'],
        featureName: 'Announcement',
      },
      lfFeatureOn: ['announcement-page'],
    },
  },
  {
    path: 'equipmentSettings/entertainment',
    component: EntertainmentComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'iptv',
        component: EntertainmentIptvComponent,
        canActivate: [AuthGuard],
        data: {
          meta: {
            title: 'ENTERTAINMENT',
            breadcrumb: ['MENU.EQUIPSETTING', 'ENTERTAINMENT', 'IPTV'],
            featureName: 'Entertainment',
          },
          lfFeatureOn: ['entertainment-page'],
        },
      },
      { path: 'apps', redirectTo: 'internet', pathMatch: 'full' },
      {
        path: 'internet',
        component: EntertainmentInternetComponent,
        canActivate: [AuthGuard],
        data: {
          meta: {
            title: 'ENTERTAINMENT',
            breadcrumb: ['MENU.EQUIPSETTING', 'ENTERTAINMENT', 'INTERNET'],
            featureName: 'Entertainment',
          },
          lfFeatureOn: ['entertainment-page'],
        },
      },
    ],
  },
  {
    path: 'manageFeatureFlags',
    component: FeatureFlagsComponent,
    canActivate: [AuthGuard],
    data: {
      meta: {
        featureName: 'Manage Feature Flags',
      },
      lfFeatureOn: 'feature-flag-admin',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(hybridImpersonatedRoutes)],
  exports: [RouterModule],
})
export class PostLoginRoutingModule {}
